export default {
  badge: 'Test',
  badge_title: 'Ristorante di prova',
  notice: 'Questo è un ristorante di prova. Gli ordini effettuati qui sono a scopo di test.',
};
